import api_comm from "./lib";

import { isWeb } from "../utils/utils";

async function attachFiles(storemember_guid, storemember_details) {
	let base64 = storemember_details["ID/Passport Document"]?.uri?.split(",")[1];

	let File = isWeb()
		? base64
		: storemember_details["ID/Passport Document"]?.uri;

	let params = {
		document: {
			id_document: File,
		},
	};

	return api_comm(
		"post",
		"/members/api/v2/account/" + storemember_guid + "/attach",
		params
	);
}

export default attachFiles;
